import { Logo } from "@/components/Logo";
import { scrollTo } from "@/components/Navbar";
import { LICENSE_LINE } from "@/lib/company";
import { Mail, MessageCircle } from "lucide-react";

export const Footer = () => {
  const isHome = window.location.pathname === "/";
  const sectionHref = (id) => (isHome ? undefined : `/#${id}`);
  return (
    <footer id="contact" data-testid="site-footer" className="pt-20 pb-10 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 pb-14 border-b border-white/5">
          <div>
            <Logo />
            <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-xs">
              Boutique Dubai real-estate advisory — guiding first-time buyers and investors from
              first question to title deed, the RERA way.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Explore</p>
            <div className="flex flex-col gap-3 text-sm text-zinc-300">
              {isHome ? (
                <>
                  <button data-testid="footer-link-guide" onClick={() => scrollTo("guide")} className="text-left hover:text-gold-light transition-colors w-fit">Buyer's Mini Guide</button>
                  <button data-testid="footer-link-checklist" onClick={() => scrollTo("checklist")} className="text-left hover:text-gold-light transition-colors w-fit">Beginner's Checklist</button>
                  <button data-testid="footer-link-services" onClick={() => scrollTo("services")} className="text-left hover:text-gold-light transition-colors w-fit">Services</button>
                  <button data-testid="footer-link-booking" onClick={() => scrollTo("booking")} className="text-left hover:text-gold-light transition-colors w-fit">Book a Consultation</button>
                </>
              ) : (
                <>
                  <a href="/#guide" data-testid="footer-link-guide" className="hover:text-gold-light transition-colors w-fit">Buyer's Mini Guide</a>
                  <a href="/#checklist" data-testid="footer-link-checklist" className="hover:text-gold-light transition-colors w-fit">Beginner's Checklist</a>
                  <a href="/#services" data-testid="footer-link-services" className="hover:text-gold-light transition-colors w-fit">Services</a>
                  <a href="/#booking" data-testid="footer-link-booking" className="hover:text-gold-light transition-colors w-fit">Book a Consultation</a>
                </>
              )}
              <a href="/listings" data-testid="footer-link-listings" className="hover:text-gold-light transition-colors w-fit">Listings</a>
              <a href="/blog" data-testid="footer-link-blog" className="hover:text-gold-light transition-colors w-fit">Journal</a>
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Reach out</p>
            <div className="flex flex-col gap-3 text-sm text-zinc-300">
              <a href="mailto:support@havenandhillproperties.com" data-testid="footer-email-link"
                 className="flex items-center gap-2.5 hover:text-gold-light transition-colors w-fit">
                <Mail size={14} className="text-gold" /> support@havenandhillproperties.com
              </a>
              <a href="https://wa.me/971588123628" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
                 className="flex items-center gap-2.5 hover:text-gold-light transition-colors w-fit">
                <MessageCircle size={14} className="text-gold" /> WhatsApp +971 58 812 3628
              </a>
              <a href="/admin/login" data-testid="footer-admin-link"
                 className="text-xs text-zinc-600 hover:text-zinc-400 transition-colors w-fit mt-4">
                Team login
              </a>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-white/5 -mt-6 mb-8" data-testid="footer-statutory-notice">
          <p className="text-[11px] text-zinc-600 leading-relaxed">
            Haven and Hill Properties L.L.C is a real-estate brokerage operating in Dubai under RERA/DLD regulation.
            Prices, availability, payment plans and yields shown are indicative and may change without notice.
            Off-plan payments must only be made into DLD-approved project escrow accounts (Law No. 8 of 2007).
            Verify broker cards and Trakheesi permits on the Dubai REST app. Nothing here is legal, tax or financial advice.
          </p>
          {LICENSE_LINE && (
            <p className="mt-2 text-[11px] text-zinc-500" data-testid="footer-rera-license">
              {LICENSE_LINE}
            </p>
          )}
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">© {new Date().getFullYear()} Haven and Hill Properties L.L.C, Dubai. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-zinc-500">
            <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-gold-light transition-colors">Privacy Policy</a>
            <a href="/terms" data-testid="footer-terms-link" className="hover:text-gold-light transition-colors">Terms &amp; Conditions</a>
          </div>
        </div>
        <p className="mt-4 text-[11px] text-zinc-700 max-w-2xl leading-relaxed">
          Market content is general guidance based on public DLD/RERA information — not legal or financial advice.
        </p>
      </div>
    </footer>
  );
};
